import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

const sections = [
  {
    title: '1. Information We Collect',
    content: `We collect information you provide directly, including your name, email address, phone number, mailing address, date of birth, government-issued identification, financial information (income, net worth, investment experience), and accreditation documentation. We also collect information automatically when you use our platform, such as IP address, browser type, device information, pages visited, and cookies.`,
  },
  {
    title: '2. How We Use Your Information',
    content: `We use your information to: provide and maintain our investment platform; process investment transactions; verify your identity and accreditation status; comply with legal and regulatory obligations (including KYC/AML requirements); communicate with you about investment opportunities, account updates, and platform changes; improve our services and user experience; and protect against fraud and unauthorized access.`,
  },
  {
    title: '3. Information Sharing',
    content: `We do not sell your personal information. We may share your information with: portfolio companies and co-investors as necessary to facilitate investments; service providers who assist in operating our platform (payment processors, identity verification, cloud hosting); legal and regulatory authorities when required by law; and professional advisors (auditors, lawyers) in connection with our business operations.`,
  },
  {
    title: '4. Data Security',
    content: `We implement industry-standard security measures to protect your personal information, including encryption in transit and at rest, access controls, regular security audits, and secure data storage. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.`,
  },
  {
    title: '5. Cookies and Tracking',
    content: `We use cookies and similar technologies to enhance your experience, analyze usage patterns, and deliver relevant content. You can manage cookie preferences through your browser settings. Essential cookies are required for platform functionality; analytics and marketing cookies are optional.`,
  },
  {
    title: '6. Your Rights (GDPR & International)',
    content: `If you are located in the European Economic Area or other jurisdictions with data protection laws, you have the right to: access your personal data; request correction of inaccurate data; request deletion of your data (subject to legal retention requirements); object to or restrict certain processing; data portability; and withdraw consent. To exercise these rights, contact us at team@iangels.com.`,
  },
  {
    title: '7. Data Retention',
    content: `We retain your personal information for as long as your account is active and as required by applicable financial regulations. Investment records are retained for a minimum of seven years following the conclusion of the relevant investment, as required by law.`,
  },
  {
    title: '8. Changes to This Policy',
    content: `We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the updated policy on our platform and, where appropriate, by email. Your continued use of the platform after changes constitutes acceptance of the updated policy.`,
  },
  {
    title: '9. Contact Us',
    content: `If you have questions about this Privacy Policy or our data practices, please contact us at:\n\niAngels Ltd.\nRothschild Blvd 18, Tel Aviv, Israel\nEmail: team@iangels.com\nPhone: +972 3 901 3760`,
  },
];

export default function PrivacyPolicy() {
  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth="md">
        <Typography variant="h3" fontWeight={700} gutterBottom>Privacy Policy</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Last updated: March 2026</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
          iAngels Ltd. ("iAngels", "we", "us", or "our") is committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our investment platform.
        </Typography>
        <Divider sx={{ mb: 4 }} />
        {sections.map((s, i) => (
          <Box key={i} sx={{ mb: 4 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>{s.title}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, whiteSpace: 'pre-line' }}>{s.content}</Typography>
          </Box>
        ))}
      </Container>
    </Box>
  );
}
